export const USER_TYPE_ITEMS = ['Interno','Externo']
